import React from 'react'; import YouTube from 'react-youtube';
import { connect } from "react-redux";
import Tone from 'tone';
import domToImage from 'dom-to-image';
import ConditionedComponent from 'components/ConditionedComponent.js';
import recorder from '../../recorder.js';
import axios from 'axios';
import StartAudioContext from 'startaudiocontext';
import ipfs from 'decentralized/Ipfs.js';
import {YOUTUBE, VINYL} from './constants.js';
import { Label, Button, Input, ButtonDropdown, DropdownToggle, DropdownMenu, DropdownItem } from 'reactstrap';
import SoundUploader from 'api/SoundUploader.js';
import SampledSound from 'components/SampledSound.js';
import { Badge } from 'reactstrap';

import '../../Discover.scss';
import '../../App.css';

class YoutubeSampler extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            sampling : false,
            dropdownOpen: false,
            recordingSetup : false,
            videoId: props.videoId,
            startTime: null,
            endTime: null,
            stream: undefined
        };
        var self = this;
        this.soundUploader = new SoundUploader(
            2, (soundId, ipfsHash) => this.props.onSoundUploaded(ipfsHash, ipfsHash));
        this.setupRecording();
    }

    toggleDropdown() {
        this.setState({dropdownOpen: !this.state.dropdownOpen});
    }
    
    shouldComponentUpdate(nextProps) {
        if (this.props.playOutputRecording != nextProps.playOutputRecording) {
            if (nextProps.playOutputRecording) {
                this.input.connect(this.audioContext.destination);
            } else {
                this.input.disconnect(this.audioContext.destination);
            }
        }

        if (nextProps.stream !== this.state.stream) {
            this.state.stream = nextProps.stream;
            this.startUserMedia(this.state.stream);
        }

        return true;
    }


    startUserMedia(stream) {
        console.log('starting user media');
        console.log(stream);
        this.input = this.audioContext.createMediaStreamSource(stream);
        this.input.channelCount = 2;

        this.recorder = new window.Recorder(this.input, {numChannels: 2, bufferLen:2048});
        if (this.props.playOutputRecording) {
            this.input.connect(this.audioContext.destination);
        }
        this.state.recordingSetup = true;
        this.setState(this.state);
    }

    setupRecording() {
        try {
            // webkit shim
            window.AudioContext = window.AudioContext || window.webkitAudioContext;
            navigator.getUserMedia = navigator.getUserMedia || navigator.webkitGetUserMedia;
            window.URL = window.URL || window.webkitURL;
            
            this.audioContext = Tone.Master.context;

            StartAudioContext(this.audioContext, "#playButton")
        } catch (e) {
            console.log('No web audio support in this browser!');
        }
    }

    onClickSampleButton() {
        this.state.sampling = !this.state.sampling;
        if (this.state.sampling) {
            this.state.startTime = this.youtubePlayer.getCurrentTime();
            this.recorder.record();
        } else {
            this.recorder.stop(Tone.Master.context.currentTime + 0.01);
            setTimeout(() => {
                this.state.endTime = this.youtubePlayer.getCurrentTime();
                this.recorder.getBuffer((blob) => this.saveBuffer(blob));
            }, [100]);
        }
        this.setState(this.state);
    }

    async saveBuffer(blob) {
        let ipfsHash = await this.soundUploader.uploadBufferToIpfs(
            blob, true);

        // get the cover art of selected record
        if (this.props.selectedRecord) {
            let thumbnailUrl = this.props.selectedRecord.thumb;
 
            axios.get('https://cors-anywhere.herokuapp.com/' + thumbnailUrl,
                      {
                          responseType: 'blob'
                      })
                .then(result => {
                    let blob = result.data;
                    ipfs.addBlob(blob).then(coverHash =>
                        this.props.onCoverDownloaded(ipfsHash, coverHash));
                });
        }
        
        this.recorder.clear();
    }

    getRelatedVideos() {
        console.log('get related videos event dispatched');
        window.dispatchEvent(new Event('get_related_videos'));
    }

    getRecordLabels() {
        window.dispatchEvent(new Event('get_record_labels'));
    }

    fastForward(e) {
        e.preventDefault();
        this.youtubePlayer.seekTo(this.youtubePlayer.getCurrentTime() + 5);
    }

    rewind(e) {
        e.preventDefault();
        this.youtubePlayer.seekTo(this.youtubePlayer.getCurrentTime() - 5);
    }

    checkQuality() {
        let qualities = this.youtubePlayer.getAvailableQualityLevels();
        this.youtubePlayer.setPlaybackQuality(qualities[0]);
    }

    render() {
        console.log('selected record = ');
        console.log(this.props.selectedRecord);
        const opts = {
            height: '125',
            width: '400',
            playerVars: { // https://developers.google.com/youtube/player_parameters
                autoplay: 1
            }
        };

        let styles = this.props.styles;
        let country = this.props.country;
        let year = this.props.yeaer;
        if (this.props.sampleSource === VINYL &&
            this.props.selectedRecord) {
            styles = this.props.selectedRecord.style;
            country = this.props.selectedRecord.country;
            year = this.props.selectedRecord.year;
        }

        return (
            <div className="youtube-sampler">
              <span className="#playButton"></span>
              <ConditionedComponent condition={this.props.sampleSource === YOUTUBE}>
                <div className="youtube-widget-container">
                  <YouTube
                    videoId={this.props.videoId}
                    opts={opts}
                    onStateChange={(e) => this.checkQuality()}
                    onReady={(e) => this._onReady(e)}
                    />
                </div>
              </ConditionedComponent>
              <ConditionedComponent condition={this.props.sampleSource === VINYL}>
                <img className="cover-art" src={this.props.selectedRecord ? this.props.selectedRecord.cover_image : ''}/>
              </ConditionedComponent>
               <div className="video-info-container">
              </div>
              <div className="video-buttons-container">
                <div className="action-buttons">
                {this.state.recordingSetup ? 
                    <span onClick={() => this.onClickSampleButton()}
                          className={this.state.sampling ? 'record-button recording' : "record-button"}>
                      {this.state.sampling ? 'RECORDING' : 'RECORD'}
                    </span>
                : '... initalizing'}
                  </div>
                <div className="action-buttons">
                  <span onClick={(e) => this.rewind(e)} className='big-button player-button'>RRWD</span>
                </div>
                <div className="action-buttons">
                  <span onClick={(e) => this.fastForward(e)} className='big-button player-button'>FFWD</span>
                </div>
                <div className="action-buttons">
                  <span onClick={this.props.onClickTag} className='big-button tag-samples-button'>TAG</span>
                </div>
                <div className="float-right">
                  <ConditionedComponent condition={this.props.sampleSource === YOUTUBE}>
                <ButtonDropdown
                               show={this.state.dropdownOpen}
                               isOpen={this.state.dropdownOpen}
                               toggle={() => this.toggleDropdown()}>
                                   <Button
                                         onClick={() => this.getRelatedVideos()}
                                         id="caret" color="secondary"><span className="">Related</span></Button>
                               <DropdownToggle size="sm" caret color="secondary">
                               </DropdownToggle>
                               <DropdownMenu>
                                 <DropdownItem onClick={() => this.getRelatedVideos()} size="sm">Related Videos</DropdownItem>
                                 <DropdownItem onClick={() => this.getRecordLabels()} size="sm">Record Labels</DropdownItem>
                                 <DropdownItem onClick={() => this.props.onClickRandomVideo()} size="sm">Random Video</DropdownItem>
                               </DropdownMenu>
                             </ButtonDropdown>
                  </ConditionedComponent>
              </div>
              </div>
              <div className="discogs-container">
                Styles:  {styles.map((style) => <Badge color="light">{style}</Badge>)} {year !== undefined ? "Year: " + year : ''}
                {country !== undefined ? " Country: " + country: ''}
              </div>
              </div>
        );
    }

    _onReady(event) {
        this.youtubePlayer = event.target;
        this.setState(this.state);
    }
}

const mapStateToProps = state => {
    return {
        selectedRecord: state.discover.selectedRecord,
    };
};

function loadXHR(url) {

    return new Promise(function(resolve, reject) {
        console.log('loading image');
        let node = document.getElementById("selected-record");
        var options = {
        quality: 0.95 
        };

        domToImage.toJpeg(node, options).then(function (dataUrl) {
            console.log('got the image');
            console.log(dataUrl);
            // Do something with the dataURL (data:image/jpeg;base64,i........)
        });
    });
}
function str2ab(str) {
  var buf = new ArrayBuffer(str.length*2); // 2 bytes for each char
  var bufView = new Uint16Array(buf);
  for (var i=0, strLen=str.length; i < strLen; i++) {
    bufView[i] = str.charCodeAt(i);
  }
  return buf;
}
export default connect(mapStateToProps, null)(YoutubeSampler);

